import { IStyle, classNamesFunction } from '@fluentui/react';
import { IThemedProp } from './themesUI';

export interface IGroupmeBrandedHeaderStyles {
    brandedHeader: IStyle;
    groupmeBrand: IStyle;
    row: IStyle;
    headerBrand: IStyle;
    headerText: IStyle;
    subHeaderText: IStyle
}

export const getGroupmeBrandedHeaderStyles = (props: IThemedProp): IGroupmeBrandedHeaderStyles => {
    const { theme } = props;
    return {
        brandedHeader: {
            backgroundColor: '#1873ba',
            color: '#fff',
            paddingTop: '10px',
            paddingRight: '0px',
            paddingBottom: '15px',
            paddingLeft: '0px',
            width: '100%',
            marginBottom: '2rem',
        },
        groupmeBrand: {
            backgroundColor: '#1873ba',
            color: '#fff',
            paddingTop: '10px',
            paddingRight: '0px',
            paddingBottom: '15px',
            paddingLeft: '0px',
        },
        row: {
            padding: '0',
            margin: '0',
            selectors: {
                '::before': {
                    display: 'table',
                    content: "' '",
                    boxSizing: 'border-box',
                },
                ':after': {
                    clear: 'both',
                    display: 'table',
                    content: "' '",
                    boxSizing: 'border-box',
                },
            },
        },
        headerBrand: {
            fontSize: '44px',
            lineHeight: '64px',
            padding: '0',
            margin: '0',
            color: theme.palette.white,
            fontFamily: "'Segoe UI Semibold', 'wf_segoe-ui_semibold', 'wf_segoe-ui_normal', 'Segoe UI', 'Segoe WP', Tahoma, Arial, sans-serif",
            selectors: {
                '::before': {
                    boxSizing: 'border-box',
                },
                ':after': {
                    boxSizing: 'border-box',
                },
            },
        },
        headerText: {
            marginTop: '5px',
            marginRight: '0px',
            marginBottom: '5px',
            marginLeft: '0px',
            fontSize: '24px',
            color: theme.palette.white,
            fontWeight: 'bold',
            fontFamily: "'Segoe UI', 'wf_segoe-ui_semibold', 'wf_segoe-ui_normal', 'Segoe WP', Tahoma, Arial, sans-serif !important",
            selectors: {
                '::before': {
                    boxSizing: 'border-box',
                },
                ':after': {
                    boxSizing: 'border-box',
                },
            },
        },
        subHeaderText: {
            marginTop: '5px',
            marginRight: '0px',
            marginBottom: '5px',
            marginLeft: '0px',
            fontSize: '18px',
            color: theme.palette.white,
            fontWeight: 'normal',
            fontFamily: "'Segoe UI', 'wf_segoe-ui_semibold', 'wf_segoe-ui_normal', 'Segoe WP', Tahoma, Arial, sans-serif !important",
            selectors: {
                '::before': {
                    boxSizing: 'border-box',
                },
                ':after': {
                    boxSizing: 'border-box',
                },
            },
        },
    };
};

export const getGroupmeBrandedHeaderClassNames = classNamesFunction<{}, IGroupmeBrandedHeaderStyles>();
